import _ from "lodash";
import axios from "axios";

import { canaveral_url, sisi_api_url } from "../api";

export function searchFlights(payload: any) {
  return axios.post(`${sisi_api_url}/flightengine/search/`, payload);
}

export async function fetchSavedFlightSearchResults({
  session_id,
  page_size = 1000,
  ordering = "price",
  api_key,
}: {
  session_id: string;
  page_size?: number;
  ordering?: string;
  api_key?: string;
}) {
  try {
    const response = await axios.get(`${sisi_api_url}/flightengine/search/${session_id}`, {
      params: { page_size, ordering, api_key },
    });
    return response.data;
  } catch {
    return null;
  }
}

export async function fetchSavedFlSearchResults({
  session_id,
  page_size = 1000,
  ordering = "price",
  api_key,
}: {
  session_id: string;
  page_size?: number;
  ordering?: string;
  api_key?: string;
}) {
  return axios.get(`${sisi_api_url}/flightengine/search/${session_id}`, {
    params: { page_size, ordering, api_key },
  });
}

export function flightPrebook(payload) {
  return axios.post(`${sisi_api_url}/flightengine/prebook`, payload);
}

export async function createFlightBooking({ payload }) {
  try {
    const response = await axios.post(`${canaveral_url}/book-flight/`, payload);
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
}
